/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OktaResourceConnectionServer,
  OktaResourceConnectionServer$inboundSchema,
} from "./oktaresourceconnectionserver.js";

export type ConfirmOktaResourceConnectionsResult = {
  /**
   * The confirmed servers with their new state.
   */
  servers: Array<OktaResourceConnectionServer>;
};

/** @internal */
export const ConfirmOktaResourceConnectionsResult$inboundSchema: z.ZodMiniType<
  ConfirmOktaResourceConnectionsResult,
  unknown
> = z.object({
  servers: z.array(OktaResourceConnectionServer$inboundSchema),
});

export function confirmOktaResourceConnectionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ConfirmOktaResourceConnectionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ConfirmOktaResourceConnectionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConfirmOktaResourceConnectionsResult' from JSON`,
  );
}
